const PREFIX = "MODAL_",
  SET = "SET_";

/**
 * @name HIDE_MODAL
 * @const
 * @description Hides the modal.
 */
export const HIDE_MODAL = PREFIX + "HIDE_MODAL";

/**
 * @name SHOW_MODAL
 * @const
 * @description Show the modal.
 */
export const SHOW_MODAL = PREFIX + "SHOW_MODAL";

/**
 * @name SET_VALUES
 * @const
 * @description Sets the values for the modal.
 */
export const SET_VALUES = PREFIX + SET + "VALUES";
